<div class="icon-list d-flex" *ngIf="statisticDataIcons().length > 0">
  <div
    class="statistic-data-icon"
    *ngFor="let stat of statisticDataIcons()"
    [ngClass]="{ 'cursor-pointer': !disabled() }"
    [matTooltip]="stat.resourceId | apmTranslate"
    (click)="onStatisticClick()"
  >
    <fa-icon [icon]="stat.icon"></fa-icon>
  </div>
</div>
